<template>
  <div id="app">
    <el-container style="height: 100%; min-width:900px">
      <el-header style="height: auto;padding: 0;margin: 0 20px;" v-show="routeLevel1.length > 0">
        <el-menu router
                 mode="horizontal"
                 :default-active="level1Path"
                 @select="onLevel1Change">
          <el-menu-item v-for="(v, k) in routeLevel1"
                        :key="k"
                        :index="v['path']"
                        :style="v['right'] ? 'float:right': ''">
            {{ v['name'] }}
          </el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <el-container style="height: 100%">
          <el-aside v-show="routeLevel2.length > 0"
                    width="180px">
            <el-menu ref="level2Menu"
                     router
                     mode="vertical"
                     :default-active="level2Path"
                     @select="onLevel2Change">
              <el-menu-item v-for="(v, k) in routeLevel2"
                            :key="k"
                            :index="v['path']">
                {{ v['name'] }}
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main style="padding: 0; margin: 0 20px"
                   class="main-content">
            <router-view />
          </el-main>
        </el-container>
      </el-main>
    </el-container>
    <el-dialog title="错误"
               :visible.sync="errDialog"
               width="80%"
               custom-class="error">
      <template>
        <div v-html="errMsgHtml"></div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import event from './../api/event'
import { mapGetters } from 'vuex'
import router from '../router'
import { sync } from 'vuex-router-sync'
import store from '../store'
sync(store, router)
import { isUndefined, concat } from 'lodash'

export default {
  components: {},
  data() {
    return {
      errDialog: false,
      errMsg: '',
      level1Path: '',
      level2Path: ''
    }
  },
    watch: {
        //监听路由
        '$route.path': function (newVal, oldVal) {
            if(newVal !== oldVal){
                this.onLevel2Change(newVal)
            }
        },
    },
  computed: {
    errMsgHtml() {
      return typeof this.errMsg === 'string'
        ? this.errMsg.split('\n').join('<br />')
        : this.errMsg
    },
    routeLevel1() {
      if (store.state.route.meta['nonav1']) {
        return []
      }

      let items = []
      for (let item of router.options.routes) {
        if ('name' in item
          ? (item.children
            ? this.menuChildAcFilter(item.children).length > 0
            : isUndefined(item.granted) || item.granted(this.ac))
          : false
        ) {
          items.push({
            path: item['path'],
            name: item['name'],
            right: item['right'] || false
          })
        }
      }
      return items
    },
    routeLevel2() {
      if (store.state.route.meta['nonav2']) {
        return []
      }

      let items = []
      for (let item of router.options.routes) {
        if ('name' in item && item['path'] === this.level1Path) {
          items = concat(items, this.menuChildAcFilter(item['children'] || []).map(child => {
            return {
              path: item['path'] + '/' + child['path'],
              name: child['name']
            }
          }))
        }
      }

      return items
    },
    ...mapGetters(['logged', 'ac'])
  },
  mounted() {
  },
  created() {
    this.level1Path = store.state.route.path.match(/^(\/[\w-]*)(\/|$)/)[1]
    this.level2Path = store.state.route.path
    this.updateTitle(store.state.route.meta)

    this.$store.dispatch('logged_in').catch(() => {
      this.$router.push('/login')
    })
    this.$router.beforeEach((to, from, next) => {
      this.updateTitle(to.meta)
      if (to.matched.some(record => record.meta['requiresAuth'])) {
        if (!this.logged) {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
          return
        }
      }
      next()
    })
    event.registerEvent('error', err => {
      this.errDialog = true
      this.errMsg = err
    })
    event.registerEvent('message', msg => {
      if (this.tip) {
        this.tip.close()
      }

      this.tip = this.$message({
        message: msg,
        type: 'success',
        duration: 1000,
        onClose: () => {
          this.tip = null
        }
      })
    })
    event.registerEvent('login', () => {
      this.$router.push('/login')
    })
  },
  methods: {
    updateTitle(meta) {
      let title = "智能研选后台"
      if (meta.title) {
        title = title + "-" + meta.title;
      }
      document.title = title
    },
    onLevel1Change(index) {
      this.level1Path = index
      this.$nextTick(() => {
        if (this.$refs.level2Menu) {
          this.$refs.level2Menu.activeIndex = store.state.route.path
        }
      })
    },
    onLevel2Change(index) {
      this.level2Path = index
      this.$nextTick(() => {
        if (this.$refs.level2Menu) {
          this.$refs.level2Menu.activeIndex = store.state.route.path
        }
      })
      this.$router.push({
        path: index
      })
    },
    menuChildAcFilter(children) {
      let ret = []
      for (let child of children) {
        if ('name' in child && (isUndefined(child.granted) || child.granted(this.ac))) {
          ret.push(child)
        }
      }
      return ret
    }
  }
}
</script>

<style>
.main-content .el-main {
  padding: 5px;
}
.el-dialog {
  margin-top: 8vh !important;
}

.ai-label {
  border-radius: 4px;
  color:whitesmoke;
  padding: 3px 5px;
  font-size: 10px;
}

.ai-label-danger {
  background-color: #F56C6C;
  border: 1px solid #F56C6C;
}

.ai-label-success {
  background-color: #67C23A;
  border: 1px solid #67C23A;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
}

html {
  height: 100%;
}
</style>
